// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v5-scroller{-webkit-tap-highlight-color:rgba(0,0,0,0);width:100%;height:100%;overflow:hidden;user-select:none}.v5-scroller-content{width:100%;transform-origin:left top;transform:translateZ(0)}", ""]);
// Exports
module.exports = exports;
